if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/serviceWorker.js').then((reg) => {
        console.log('Successfully registered service worker', {reg});
    }).catch((err) => {
        console.warn('Error whilst registering service worker', {err});
    });
}

window.addEventListener(
    'clear-storage-caches',
    () => 'serviceWorker' in navigator && caches.keys().then((cacheNames) => cacheNames.forEach((cacheName) => caches.delete(cacheName))),
    false
);